import React from 'react';
import connect from "react-redux/es/connect/connect";
import {withAuthorization} from "../../services/Authorization";
import {injectIntl} from "react-intl";
import Storage from "../../services/Storage";
import {Button, Checkbox, Divider} from "antd";
import CheckboxItem from "./CheckboxItem";
import _ from 'lodash';
import LabelEncoder from "./LabelEncoder";
import SAInputCurrency from "../common/input/SAInputCurrency";
import Constants from "../../services/Constants";
import SAInputDistance from "../common/input/SAInputDistance";
import PriceTag from '../common/pricetag/PriceTag';

const MAX_MOBILITY_TO_ADD = 2;

class MobilityDetails extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      additionalMobilityId: 0
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mobility && nextProps.mobility.extraMobility && nextProps.mobility.extraMobility.length) {
      const maxId = _.maxBy(nextProps.mobility.extraMobility, function (b) {
        return b.id;
      });
      this.state = {
        additionalMobilityId: maxId.id + 1
      }
    }
  }

  renderExtraMobility = () => {
    const {intl, intl:{formatMessage}, errors, mobility} = this.props;
    const error = errors;
    const user = Storage.getItem('user');
    const canWrite= user.role === 'DUI_ADMIN';

    let elements = [];
    if (!mobility.extraMobility) {
      return null;
    }

    mobility.extraMobility.forEach((mobility, i) => {
      elements.push(
        <li key={'mobility.'+i}>
          {canWrite ?
            <span>
              <SAInputCurrency name={"mobility.price"} onChange={value => this.onInputPriceChange(value, mobility.id)} className={"right"}
                               value={mobility.price} placeholder={formatMessage({id: 'placeholder.price'})} min={0}
                               error={error && error[`extraMobility[${i}].price`]} />
              <SAInputDistance name={`mobility.rangeOfKilometers`} onChange={value => this.onInputRangeChange(value, mobility.id)} className={"right"}
                               value={mobility.rangeOfKilometers} placeholder={formatMessage({id: 'placeholder.distance'})}
                               error={error && error[`extraMobility[${i}].rangeOfKilometers`]} />
            </span>
            :
            <span>
              <span className="right picker-right"><PriceTag price={mobility.price}/></span>
              <span className="right picker-right">{mobility.rangeOfKilometers ? `${mobility.rangeOfKilometers} Km` : ''}</span>
            </span>
          }
          <div className={"d-flex"}>
            <Checkbox checked={true} disabled={true}>
              <span>{mobility.label[intl.locale]}</span>
            </Checkbox>

            {canWrite &&
              <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={mobility.id} onValidate={(values) => this.onValidateAdditionalMobility(values, 'label')} values={mobility.label}>
                <span>
                  <a className={"smaller"}>{formatMessage({id: 'action.edit'})}</a>&nbsp;
                  <a className={"smaller"} onClick={(e) => {
                    e.stopPropagation();
                    this.removeMobility(mobility.id)
                  }}>{formatMessage({id: 'action.delete'})}</a>
                </span>
              </LabelEncoder>
            }
          </div>
          <br/>
          <ul className="list">
            {mobility.description && <p>{formatMessage({id: `${intl.locale}`})} : {mobility.description[intl.locale]}</p>}
            <span>
              {canWrite &&
                <span>
                  <li className={"list__footer" + (error[`extraMobility[${i}]`] ? " error" : "")}>
                    <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={mobility.id} mandatory={false} onValidate={(values) => this.onValidateAdditionalMobility(values, 'description')} values={mobility.description}>
                      <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                        <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                          <use xlinkHref="#icon-plus"/>
                        </svg>
                        <strong>{formatMessage({id: 'section.mobility.setDescription'})}</strong>
                      </Button>
                    </LabelEncoder>
                  </li>
                  {error && error[`extraMobility[${i}]`] &&
                    <div className={"txt-error"}>{formatMessage({id: error[`extraMobility[${i}]`].message})}</div>
                  }
                </span>
              }
            </span>
          </ul>

        </li>
      )
    });
    return elements;
  };

  renderMobility = (item, error, canWrite, itemCategory) => {
    const {name} = item;
    const err = {
      [`${name}.description`]: error[`${itemCategory}[${name}]`],
    };
    return <CheckboxItem canWrite={canWrite} onChange={(n, v) => this.onCheckboxItemChange(n, v, itemCategory)} mandatoryDescription={false} name={name} config={{price: true, range: true, languageChoice: true}}
                         placeholderPriceKey={'placeholder.price'} placeholderKilometersKey={'placeholder.rangeOfKilometers'} item={item} labelKey={`mobility.${name}`} error={err}/>
  };

  onCheckboxItemChange = (name, state, category) => {
    const {mobility} = this.props;
    mobility[category][name] = state;
    this.setState({mobility});
  };

  removeMobility = (id) => {
    const {mobility} = this.props;
    mobility.extraMobility = mobility.extraMobility.filter(e => id !== e.id);
    this.setState({mobility});
  };

  onInputPriceChange = (price, id) => {
    const {mobility} = this.props;
    const filtered = mobility.extraMobility.filter(mobility => mobility.id === id);
    if (filtered && filtered.length >= 1){
      filtered[0].price = price;
      this.setState({mobility});
    }
  };

  onInputRangeChange = (range, id) => {
    const {mobility} = this.props;
    const filtered = mobility.extraMobility.filter(mobility => mobility.id === id);
    if (filtered && filtered.length >= 1){
      filtered[0].rangeOfKilometers = range;
      this.setState({mobility});
    }
  };

  onValidateAdditionalMobility = (values, key) => {
    const {mobility} = this.props;

    if (!mobility.extraMobility) {
      mobility.extraMobility = [];
    }

    const filtered = mobility.extraMobility.filter(mobility => mobility.id === values.id);
    if (filtered && filtered.length >= 1){
      filtered[0][key] = values;
      this.setState({mobility});
    } else {
      mobility.extraMobility.push({id: values.id, [key]: values, active: true, price: values.price});
      this.setState({mobility, additionalMobilityId: this.state.additionalMobilityId + 1});
    }

    this.setState({});
  };

  render() {
    const {intl:{formatMessage}, mobility, errors} = this.props;
    const {categoryMobility = {}, otherMobility = {}, serviceMobility = {}} = mobility;
    const user = Storage.getItem('user');
    const canWrite = user.role === 'DUI_ADMIN';
    const canAddService = !mobility.extraMobility || mobility.extraMobility.length < MAX_MOBILITY_TO_ADD;

    const categoryMobilityList = [];
    Object.keys(categoryMobility).forEach(key => categoryMobilityList.push(categoryMobility[key]));
    categoryMobilityList.sort((a, b) => a.order - b.order);

    const otherMobilityList = [];
    Object.keys(otherMobility).forEach(key => otherMobilityList.push(otherMobility[key]));
    otherMobilityList.sort((a, b) => a.order - b.order);

    const serviceMobilityList = [];
    Object.keys(serviceMobility).forEach(key => serviceMobilityList.push(serviceMobility[key]));
    serviceMobilityList.sort((a, b) => a.order - b.order);

    return (
      <div className="box__body">
        <div className="row">
          <div className="col-md-6 col-xxl-6">
            <h3 className="box__subtitle">{formatMessage({id:'section.mobility.main.title'})} ({formatMessage({id: 'include.vat'})})</h3>
            <ul className="list li-margin">
              {categoryMobilityList.map(m => <li key={m.name}>{this.renderMobility(m, errors, canWrite, 'categoryMobility')}</li>)}
              {errors && errors.categoryMobility && <div className={"txt-error"}>{formatMessage({id: errors.categoryMobility.message})}</div>}
            </ul>
          </div>
          <div className="col-md-6 col-xxl-6">
            <h3 className="box__subtitle">{formatMessage({id:'section.mobility.other.title'})} ({formatMessage({id: 'include.vat'})})</h3>
            <ul className="list li-margin">
              {otherMobilityList.map(m => <li key={m.name}>{this.renderMobility(m, errors, canWrite, 'otherMobility')}</li>)}
              {serviceMobilityList.map(m => <li key={m.name}>{this.renderMobility(m, errors, canWrite, 'serviceMobility')}</li>)}
            </ul>
          </div>
          <Divider/>
          <div className="col-md-6 col-xxl-6">
            <h3 className="box__subtitle">{formatMessage({id:'section.extra-mobility.title'})} ({formatMessage({id: 'include.vat'})})</h3>
            <ul className="list li-margin">
              {this.renderExtraMobility()}
              {canAddService && canWrite &&
              <li className="list__footer">
                <LabelEncoder keys={Constants.SUPPORTED_LANGUAGES} labelId={this.state.additionalMobilityId} onValidate={(values) => this.onValidateAdditionalMobility(values, 'label')}>
                  <Button className="btn btn-link js-dropdown-trigger add-more-btn">
                    <svg className="bmw-icon-sm mr-1" aria-hidden="true">
                      <use xlinkHref="#icon-plus"/>
                    </svg>
                    <strong>{formatMessage({id:'add.more'})}</strong>
                  </Button>
                </LabelEncoder>
              </li>}
            </ul>

          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  fetchMobility: state.fetchMobility,
  saveMobility: state.saveMobility
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchMobility: () => dispatch({type: 'FETCH_MOBILITY.REQUEST'}),
  dispatchSaveMobility: (body) => dispatch({type: 'SAVE_MOBILITY.REQUEST', body})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(MobilityDetails), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));



// WEBPACK FOOTER //
// ./src/components/dealership/MobilityDetails.js